import { addDays, addMonths } from "date-fns";
import { formatPrecisaoFloat } from "../../../utils";

export function recalcularCascataDeValores(itemAtual, nomeCampo, novoValor) {
  let item = { ...itemAtual, [nomeCampo]: novoValor || 0 };

  const quantidade = parseFloat(item.quantidade || 0);
  const valorUnitario = parseFloat(item.valorUnitario || item.valor || 0);
  const subtotal = quantidade * valorUnitario;

  if (
    nomeCampo === "quantidade" ||
    nomeCampo === "valorUnitario" ||
    nomeCampo === "valor"
  ) {
    if (item.descontoPorcentagem > 0) {
      item.desconto = (subtotal * parseFloat(item.descontoPorcentagem)) / 100;
    } else if (item.desconto > 0) {
      if (item.desconto > subtotal) item.desconto = subtotal;
      item.descontoPorcentagem =
        subtotal > 0 ? (item.desconto / subtotal) * 100 : 0;
    }
  }

  const despesas = parseFloat(item.despesas || 0);
  const frete = parseFloat(item.frete || 0);
  const totalLiquido =
    subtotal - parseFloat(item.desconto || 0) + despesas + frete;

  item.subtotal = subtotal;
  item.totalItem = totalLiquido;
  item.total = totalLiquido;

  return item;
}

export function totalPagamentos(listaPagamentos) {
  if (listaPagamentos?.length) {
    const total = listaPagamentos.reduce(
      (prevVal, elem) => prevVal + parseFloat(elem.valorTitulo),
      0,
    );
    return total;
  }
  return 0;
}

export function parcelaData(indice, intervaloDias) {
  const dias = indice * (intervaloDias ?? 1);
  const meses = Math.floor(dias / 30);
  const diasRestantes = dias % 30;
  const dataAtualizada = addMonths(new Date(), meses);
  const dataFinal = addDays(dataAtualizada, diasRestantes);
  return dataFinal;
}

export function calculaSubtotalParaChave(lista, tipoOperacao, chave) {
  if (lista?.length) {
    const valorCalculado = lista.reduce((acumulador, objetoAtual) => {
      return formatPrecisaoFloat(
        acumulador + parseFloat(objetoAtual[chave] ?? 0),
      );
    }, 0);
    return tipoOperacao !== chave ? valorCalculado : 0;
  }
  return 0;
}

export function calcularPrecoProduto(
  produto,
  tabelaVenda = null,
  meioPagamentoId,
  tipoTabela,
) {
  const preco = produto?.precoVenda || 0;
  const tabelaMeioPag = tabelaVenda?.meioPagamentoIds.length
    ? tabelaVenda?.meioPagamentoIds.find(
        ({ fatMeioPagamentoId }) => fatMeioPagamentoId === meioPagamentoId,
      )
    : null;
  if ((tipoTabela == "meioPagamento" && !tabelaMeioPag) || !tabelaVenda) {
    return produto;
  }
  if (tabelaVenda.tipoTabela === "POR_PRODUTO") {
    let tabelaVendaProduto = tabelaVenda;
    if (tabelaVenda?.itens.length) {
      tabelaVendaProduto = tabelaVenda.itens.find(
        ({ estProdutoId }) =>
          estProdutoId === produto.id || estProdutoId === produto?.produtoId,
      );
    }
    if (
      tabelaVendaProduto &&
      produto?.quantidade >= tabelaVendaProduto?.quantidadeMinima
    ) {
      const valorUnitario = formatPrecisaoFloat(
        tabelaVendaProduto.precoPraticado,
      );
      return {
        ...produto,
        valorUnitario,
        totalItem: valorUnitario * (parseFloat(produto?.quantidade) || 1),
      };
    }
    return produto;
  } else {
    const porcentagem = formatPrecisaoFloat(tabelaVenda.fator / 100);
    const valorDescontoAcrescimo = formatPrecisaoFloat(preco * porcentagem);
    if (tabelaVenda.operacao === "subtrair") {
      return {
        ...produto,
        descontoPorcentagem: tabelaVenda.fator,
        desconto: valorDescontoAcrescimo,
      };
    } else {
      return {
        ...produto,
        despesas: valorDescontoAcrescimo,
      };
    }
  }
}

export function totalItens(lista) {
  if (lista?.length) {
    const total = lista.reduce(
      (prevVal, elem) => prevVal + parseFloat(elem.totalItem || 0),
      0,
    );
    return total;
  }
  return 0;
}

export function totalItensListaProduto(listaProdutos) {
  if (listaProdutos?.length) {
    const total = listaProdutos.reduce(
      (prevVal, elem) =>
        prevVal +
        parseFloat(elem.valorUnitario || elem.valor) *
          parseFloat(elem.quantidade),
      0,
    );
    return total;
  }
  return 0;
}

export function calculoDesconto(
  itens,
  ordemServico,
  descontoName,
  descontoPorcentagemName,
  porCemParaDecimal = true,
) {
  const total = totalItensListaProduto(itens);
  let resultado = 0;
  if (porCemParaDecimal) {
    const descontoPorcentagem = parseFloat(
      ordemServico?.[descontoPorcentagemName] ?? 0,
    );
    resultado = (descontoPorcentagem / 100) * total;
    resultado = formatPrecisaoFloat(resultado, 3);
  } else {
    const desconto = parseFloat(ordemServico?.[descontoName] ?? 0);
    resultado = (desconto / formatPrecisaoFloat(total)) * 100;
    resultado = formatPrecisaoFloat(resultado, 3);
  }
  return resultado;
}

export function calculoDescontoServico(servicoAtual, porCemParaDecimal = true) {
  let resultado;
  const total =
    parseFloat(servicoAtual?.valor) * parseFloat(servicoAtual?.quantidade || 0);
  if (porCemParaDecimal) {
    const descontoPorcentagem = parseFloat(
      servicoAtual?.descontoPorcentagem ?? 0,
    );
    resultado = (descontoPorcentagem / 100) * total;
    resultado = formatPrecisaoFloat(resultado, 3);
  } else {
    const desconto = parseFloat(servicoAtual?.desconto ?? 0);
    resultado = (desconto / formatPrecisaoFloat(total)) * 100;
    resultado = formatPrecisaoFloat(resultado, 3);
  }
  return resultado;
}

export function calcularValorTotal(produto) {
  const total =
    parseFloat(produto?.valorUnitario) * produto?.quantidade -
    parseFloat(produto?.desconto || 0);
  return total;
}

export function calcularValorTotalServico(servico) {
  const total =
    parseFloat(servico?.valor) * servico.quantidade -
    parseFloat(servico?.desconto || 0);
  return total;
}

export function totalListaServicos(listaServicos) {
  if (listaServicos?.length) {
    const total = listaServicos.reduce(
      (prevVal, elem) =>
        prevVal + parseFloat(elem.valor) * parseFloat(elem?.quantidade || 1),
      0,
    );
    return total;
  }
}

const subtotalItem = (item) =>
  formatPrecisaoFloat(
    item.subtotal || item.quantidade * (item.valorUnitario || item.valor),
  );

export function totalItensLista(listaNfSaidaProdutos) {
  if (listaNfSaidaProdutos?.length) {
    return listaNfSaidaProdutos.reduce(
      (prevVal, elem) => formatPrecisaoFloat(prevVal + subtotalItem(elem)),
      0,
    );
  }
}

export function totalVenda(nfSaida, nfSaidaItens, calculoTotalizadores) {
  const freteNota =
    nfSaida?.freteCompoeNota === true ? parseFloat(nfSaida?.frete ?? 0) : 0;
  const subtotalProdutos = totalItensLista(nfSaidaItens);
  const subtotalDesconto = calculaSubtotalParaChave(
    nfSaidaItens,
    calculoTotalizadores,
    "desconto",
  );
  const subtotalAcrescimo = calculaSubtotalParaChave(
    nfSaidaItens,
    calculoTotalizadores,
    "acrescimo",
  );
  const subtotalDespesas = calculaSubtotalParaChave(
    nfSaidaItens,
    calculoTotalizadores,
    "despesas",
  );
  return formatPrecisaoFloat(
    (subtotalProdutos || 0) -
      (subtotalDesconto || 0) +
      (subtotalAcrescimo || 0) +
      (subtotalDespesas || 0) +
      (freteNota || 0) +
      (nfSaida?.subtotalTributosIncidentes || 0),
  );
}

export function getIndexItemMaisCaro(lista) {
  return lista.reduce(
    (maxIndex, currentItem, currentIndex, array) =>
      subtotalItem(currentItem) > subtotalItem(array[maxIndex])
        ? currentIndex
        : maxIndex,
    0,
  );
}

function ajustarDiferenca(key, valorTotal, listaAtualizada) {
  const subtotal = calculaSubtotalParaChave(listaAtualizada, "", key);
  if (valorTotal !== subtotal && valorTotal > 0 && subtotal > 0) {
    const indiceItemMaisCaro = getIndexItemMaisCaro(listaAtualizada);
    const diferenca = formatPrecisaoFloat(valorTotal - subtotal);
    listaAtualizada[indiceItemMaisCaro][key] += diferenca;
  }
}

export function calcularTotal(item) {
  return (
    item.quantidade * (item.valorUnitario || item.valor) -
    (item.desconto || 0) +
    (item.despesas || 0)
  );
}

export function formatProdutosTotalizadores(
  name,
  itens,
  valueInputReal,
  totalNota,
) {
  const valueInput = parseFloat(valueInputReal || 0);
  let listaAtualizada = itens.map((item) => {
    const valorProporcional =
      formatPrecisaoFloat((subtotalItem(item) * 100) / totalNota) / 100;
    const itemTemp = {
      ...item,
      [name]:
        valueInput > 0
          ? formatPrecisaoFloat(valorProporcional * valueInput)
          : 0,
    };
    const totalItem = calcularTotal(itemTemp);
    return {
      ...itemTemp,
      totalItem,
    };
  });
  ajustarDiferenca(name, valueInput, listaAtualizada);
  return listaAtualizada;
}

function normalizarAtivo(ativo) {
  const nome = ativo.nome || "Ativo";

  const camposResolvidos =
    ativo.camposParaRenderizar ?? ativo.camposPersonalizados ?? [];

  const campos = camposResolvidos
    .filter((campo) => campo.value)
    .map((campo) => ({
      label: campo.label,
      value: String(campo.value),
    }));

  return {
    nome,
    campos,
    ativado: ativo.ativado !== false,
    ordem: ativo.ordem || 0,
  };
}

export function formatarAtivos(ativos) {
  if (!ativos?.length) return "NENHUM ATIVO VINCULADO.";

  const normalizados = ativos
    .map(normalizarAtivo)
    .filter((ativo) => ativo.ativado)
    .sort((a, b) => a.ordem - b.ordem);

  if (!normalizados.length) return "NENHUM ATIVO VINCULADO.";

  return normalizados
    .map(({ nome, campos }) => {
      let texto = `*${nome}*`;
      if (campos.length) {
        texto += `\n${campos.map((c) => `${c.label}: ${c.value}`).join("\n")}`;
      }
      return texto.toUpperCase();
    })
    .join("\n\n");
}

export function possuiChecklistLancado(ordemServico) {
  return (
    (ordemServico?.avarias || []).length > 0 ||
    (ordemServico?.acessorios || []).some((acessorio) => acessorio?.contem) ||
    (ordemServico?.imagens || []).length > 0 ||
    !!ordemServico?.observacoesChecklist
  );
}

export function calculaDiferencaDias(inicial, final) {
  const dataInicial = new Date(inicial);
  const dataFinal = new Date(final);
  dataFinal.setHours(0, 0, 0, 0);
  return Math.ceil((dataFinal - dataInicial) / (1000 * 60 * 60 * 24));
}
